import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
}
export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hoverEffect = true
}) => {
  return <div className={`
        bg-white rounded-lg p-6 border border-gray-100
        ${hoverEffect ? 'transition-all duration-300 hover:shadow-card-hover' : ''}
        ${className}
      `} data-id="element-563">
      {children}
    </div>;
};